/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AnexoTissAliases {
  ACCORDION_DIAGNOSTICO_QUIMIO = 'accordion-diagnostico-quimio',
  ACCORDION_OPME = 'accordion-opme',
  ACCORDION_QUIMIO = 'accordion-quimio',
  ACCORDION_RADIO = 'accordion-radio',
  ACCORDION_SITUACAO_INICIAL = 'accordion-situacao-inicial',
  FETCH_OPME_DADO = 'fetch-opme-dado',
  FETCH_QUIMIO_CID = 'fetch-quimio-cid',
  FETCH_QUIMIO_DADO = 'fetch-quimio-dado',
  FETCH_QUIMIO_DIAGNOSTICO = 'fetch-quimio-diagnostico',
  FETCH_RADIO_CID = 'fetch-radio-cid',
  FETCH_RADIO_DADO = 'fetch-radio-dado',
  FETCH_RADIO_DIAGNOSTICO = 'fetch-radio-diagnostico',
  FETCH_SITUACAO_INICIAL_DADO = 'fetch-situacao-inicial-dado',
  FIELD_0 = 'field-0',
  FIELD_26 = 'field-26',
  FIELD_27 = 'field-27',
  FIELD_53 = 'field-53',
  FIELD_54 = 'field-54',
  FIELD_DS_ALTERACAO_TECIDO_MOLE = 'field-dsAlteracaoTecidoMole',
  FIELD_DS_AREA_IRRADIADA = 'field-dsAreaIrradiada',
  FIELD_DS_CAPACIDADE_FUNCIONAL = 'field-dsCapacidadeFuncional',
  FIELD_DS_CAPACIDADE_FUNCIONAL2 = 'field-dsCapacidadeFuncional2',
  FIELD_DS_CONDICAO_CLINICA = 'field-dsCondicaoClinica',
  FIELD_DS_DENTE = 'field-dsDente',
  FIELD_DS_DIAGNOSTICO = 'field-dsDiagnostico',
  FIELD_DS_DIAGNOSTICO_3 = 'field-dsDiagnostico-3',
  FIELD_DS_DIAGNOSTICO_IMAGEM = 'field-dsDiagnosticoImagem',
  FIELD_DS_DOENCA_PERIODONTAL = 'field-dsDoencaPeriodontal',
  FIELD_DS_EMAIL_PROF_SOLIC = 'field-dsEmailProfSolic',
  FIELD_DS_EMAIL_PROF_SOLIC_1 = 'field-dsEmailProfSolic-1',
  FIELD_DS_EMAIL_PROF_SOLIC_RADIO = 'field-dsEmailProfSolic-radio',
  FIELD_DS_ESPECIFICACAO = 'field-dsEspecificacao',
  FIELD_DS_ESTADIA_TUMOR = 'field-dsEstadiaTumor',
  FIELD_DS_ESTADIA_TUMOR2 = 'field-dsEstadiaTumor2',
  FIELD_DS_FINALIDADE_TRATAMENTO = 'field-dsFinalidadeTratamento',
  FIELD_DS_FINALIDADE_TRATAMENTO2 = 'field-dsFinalidadeTratamento2',
  FIELD_DS_JUSTIFICATIVA = 'field-dsJustificativa',
  FIELD_DS_METASTASES = 'field-dsMetastases',
  FIELD_DS_NODULO = 'field-dsNodulo',
  FIELD_DS_OBSERVACAO = 'field-dsObservacao',
  FIELD_DS_OBSERVACAO_1 = 'field-dsObservacao-1',
  FIELD_DS_OBSERVACAO_DIAGNOSTICO = 'field-dsObservacaoDiagnostico',
  FIELD_DS_OBSERVACAO_DIAGNOSTICO_3 = 'field-dsObservacaoDiagnostico-3',
  FIELD_DS_OBSERVACAO_RADIO = 'field-dsObservacao-radio',
  FIELD_DS_PLANO_TERAPEUTICO = 'field-dsPlanoTerapeutico',
  FIELD_DS_PROCEDIMENTO_CIRURGICO = 'field-dsProcedimentoCirurgico',
  FIELD_DS_PROCEDIMENTO_CIRURGICO_RADIO = 'field-dsProcedimentoCirurgico-radio',
  FIELD_DS_QUIMIOTERAPIA = 'field-dsQuimioterapia',
  FIELD_DS_TIPO_QUIMIOTERAPIA = 'field-dsTipoQuimioterapia',
  FIELD_DS_TUMOR = 'field-dsTumor',
  FIELD_DT_DIAGNOSTICO = 'field-dtDiagnostico',
  FIELD_DT_DIAGNOSTICO_2 = 'field-dtDiagnostico-2',
  FIELD_DT_INICIO_PREVISTO = 'field-dtInicioPrevisto',
  FIELD_DT_QUIMIOTERAPIA = 'field-dtQuimioterapia',
  FIELD_DT_RADIOTERAPIA = 'field-dtRadioterapia',
  FIELD_DT_REAL_PROC_CIRURGICO = 'field-dtRealProcCirurgico',
  FIELD_DT_REAL_PROC_CIRURGICO_RADIO = 'field-dtRealProcCirurgico-radio',
  FIELD_NM_PROFISSIONAL_SOLIC = 'field-nmProfissionalSolic',
  FIELD_NM_PROFISSIONAL_SOLIC_1 = 'field-nmProfissionalSolic-1',
  FIELD_NM_PROFISSIONAL_SOLIC_RADIO = 'field-nmProfissionalSolic-radio',
  FIELD_NR_CAMPOS = 'field-nrCampos',
  FIELD_NR_CICLO_ATUAL = 'field-nrCicloAtual',
  FIELD_NR_CICLO_PREVISTO = 'field-nrCicloPrevisto',
  FIELD_NR_DIA_CICLO_ATUAL = 'field-nrDiaCicloAtual',
  FIELD_NR_TELEF_PROF_SOLIC = 'field-nrTelefProfSolic',
  FIELD_NR_TELEF_PROF_SOLIC_1 = 'field-nrTelefProfSolic-1',
  FIELD_NR_TELEF_PROF_SOLIC_RADIO = 'field-nrTelefProfSolic-radio',
  FIELD_QT_ALTURA = 'field-qtAltura',
  FIELD_QT_DOSE_DIA = 'field-qtDoseDia',
  FIELD_QT_DOSE_TOTAL = 'field-qtDoseTotal',
  FIELD_QT_INTERVALO_CICLO = 'field-qtIntervaloCiclo',
  FIELD_QT_PESO = 'field-qtPeso',
  FIELD_QT_SUPERFICIE_CORPORAL = 'field-qtSuperficieCorporal',
  FIELDSET_CID_QUIMIO = 'fieldset-cid-quimio',
  FIELDSET_CID_RADIO = 'fieldset-cid-radio',
  FORM_DIAGNOSTICO_QUIMIO = 'form-diagnostico-quimio',
  FORM_OPME = 'form-opme',
  FORM_QUIMIOTERAPIA_DADO = 'form-quimioterapia-dado',
  FORM_RADIO = 'form-radio',
  FORM_RADIO_DIAGNOSTICO = 'form-radio-diagnostico',
  FORM_SITUACAO_INICIAL = 'form-situacao-inicial',
  HPMS_CUSTOM_LIST_FIELD_SITUACAO_CLINICA = 'hpms-custom-list-field-situacao-clinica',
  INPUT_26 = 'input-26',
  INPUT_52 = 'input-52',
  INPUT_DS_CAPACIDADE_FUNCIONAL = 'input-dsCapacidadeFuncional',
  INPUT_DS_CAPACIDADE_FUNCIONAL2 = 'input-dsCapacidadeFuncional2',
  INPUT_DS_DIAGNOSTICO_IMAGEM = 'input-dsDiagnosticoImagem',
  INPUT_DS_EMAIL_PROF_SOLIC = 'input-dsEmailProfSolic',
  INPUT_DS_EMAIL_PROF_SOLIC_1 = 'input-dsEmailProfSolic-1',
  INPUT_DS_EMAIL_PROF_SOLIC_RADIO = 'input-dsEmailProfSolic-radio',
  INPUT_DS_ESTADIA_TUMOR = 'input-dsEstadiaTumor',
  INPUT_DS_ESTADIA_TUMOR2 = 'input-dsEstadiaTumor2',
  INPUT_DS_FINALIDADE_TRATAMENTO = 'input-dsFinalidadeTratamento',
  INPUT_DS_FINALIDADE_TRATAMENTO2 = 'input-dsFinalidadeTratamento2',
  INPUT_DS_METASTASES = 'input-dsMetastases',
  INPUT_DS_NODULO = 'input-dsNodulo',
  INPUT_DS_PROCEDIMENTO_CIRURGICO = 'input-dsProcedimentoCirurgico',
  INPUT_DS_PROCEDIMENTO_CIRURGICO_RADIO = 'input-dsProcedimentoCirurgico-radio',
  INPUT_DS_QUIMIOTERAPIA = 'input-dsQuimioterapia',
  INPUT_DS_TIPO_QUIMIOTERAPIA = 'input-dsTipoQuimioterapia',
  INPUT_DS_TUMOR = 'input-dsTumor',
  INPUT_DT_DIAGNOSTICO = 'input-dtDiagnostico',
  INPUT_DT_DIAGNOSTICO2 = 'input-dtDiagnostico2',
  INPUT_DT_INICIO_PREVISTO = 'input-dtInicioPrevisto',
  INPUT_DT_QUIMIOTERAPIA = 'input-dtQuimioterapia',
  INPUT_DT_RADIOTERAPIA = 'input-dtRadioterapia',
  INPUT_DT_REAL_PROC_CIRURGICO = 'input-dtRealProcCirurgico',
  INPUT_DT_REAL_PROC_CIRURGICO_RADIO = 'input-dtRealProcCirurgico-radio',
  INPUT_NM_PROFISSIONAL_SOLIC = 'input-nmProfissionalSolic',
  INPUT_NM_PROFISSIONAL_SOLIC_1 = 'input-nmProfissionalSolic-1',
  INPUT_NM_PROFISSIONAL_SOLIC_RADIO = 'input-nmProfissionalSolic-radio',
  INPUT_NR_CAMPOS = 'input-nrCampos',
  INPUT_NR_CICLO_ATUAL = 'input-nrCicloAtual',
  INPUT_NR_CICLO_PREVISTO = 'input-nrCicloPrevisto',
  INPUT_NR_DIA_CICLO_ATUAL = 'input-nrDiaCicloAtual',
  INPUT_NR_TELEF_PROF_SOLIC = 'input-nrTelefProfSolic',
  INPUT_NR_TELEF_PROF_SOLIC_1 = 'input-nrTelefProfSolic-1',
  INPUT_NR_TELEF_PROF_SOLIC_RADIO = 'input-nrTelefProfSolic-radio',
  INPUT_QT_ALTURA = 'input-qtAltura',
  INPUT_QT_DOSE_DIA = 'input-qtDoseDia',
  INPUT_QT_DOSE_TOTAL = 'input-qtDoseTotal',
  INPUT_QT_INTERVALO_CICLO = 'input-qtIntervaloCiclo',
  INPUT_QT_PESO = 'input-qtPeso',
  INPUT_QT_SUPERFICIE_CORPORAL = 'input-qtSuperficieCorporal',
  LAYOUT_ANEXO_TISS = 'layout-anexo-tiss',
  PANEL_0 = 'panel-0',
  PANEL_CID_QUIMIO = 'panel-cid-quimio',
  PANEL_DIAGNOSTICO = 'panel-diagnostico',
  PANEL_DIAGNOSTICO_QUIMIO = 'panel-diagnostico-quimio',
  PANEL_DIAGNOSTICO_RADIO = 'panel-diagnostico-radio',
  PANEL_OPME = 'panel-opme',
  PANEL_OPME_CTRL = 'panel-opme-ctrl',
  PANEL_QUIMIO = 'panel-quimio',
  PANEL_QUIMIO_CTRL = 'panel-quimio-ctrl',
  PANEL_QUIMIOTERAPIA_DADO = 'panel-quimioterapia-dado',
  PANEL_RADIO = 'panel-radio',
  PANEL_RADIO_2 = 'panel-radio-2',
  PANEL_RADIO_CTRL = 'panel-radio-ctrl',
  PANEL_RADIO_CTRL_2 = 'panel-radio-ctrl-2',
  PANEL_SITUACAO_CLINICA = 'panel-situacao-clinica',
  PANEL_SITUACAO_INICIAL = 'panel-situacao-inicial',
  PANEL_SITUACAO_INICIAL_CTRL = 'panel-situacao-inicial-ctrl',
  REPEATER_0 = 'repeater-0',
  REPEATER_1 = 'repeater-1',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_DIAGNOSTICO_QUIMIO = 'text-diagnostico-quimio',
  TEXT_DS_ALTERACAO_TECIDO_MOLE = 'text-dsAlteracaoTecidoMole',
  TEXT_DS_AREA_IRRADIADA = 'text-dsAreaIrradiada',
  TEXT_DS_DIAGNOSTICO = 'text-dsDiagnostico',
  TEXT_DS_DIAGNOSTICO_3 = 'text-dsDiagnostico-3',
  TEXT_DS_DOENCA_PERIODONTAL = 'text-dsDoencaPeriodontal',
  TEXT_DS_ESPECIFICACAO = 'text-dsEspecificacao',
  TEXT_DS_JUSTIFICATIVA = 'text-dsJustificativa',
  TEXT_DS_OBSERVACAO = 'text-dsObservacao',
  TEXT_DS_OBSERVACAO_1 = 'text-dsObservacao-1',
  TEXT_DS_OBSERVACAO_DIAGNOSTICO = 'text-dsObservacaoDiagnostico',
  TEXT_DS_OBSERVACAO_DIAGNOSTICO_3 = 'text-dsObservacaoDiagnostico-3',
  TEXT_DS_OBSERVACAO_RADIO = 'text-dsObservacao-radio',
  TEXT_DS_PLANO_TERAPEUTICO = 'text-dsPlanoTerapeutico',
  TEXT_OPME = 'text-opme',
  TEXT_QUIMIO_TITLE = 'text-quimio-title',
  TEXT_RADIO_TITLE = 'text-radio-title',
  TEXT_SITUACAO_INICIAL = 'text-situacao-inicial',
}
export { AnexoTissAliases };
